// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.status[data-v-6fb02644] {\n  padding: 5px 10px;\n  border-radius: 5px;\n  width: 150px;\n  text-align: center;\n}\n.inviteSent[data-v-6fb02644] { background-color: grey; color: white;\n}\n.awaitingSubmission[data-v-6fb02644] { background-color: orange; color: white;\n}\n.submitted[data-v-6fb02644] { background-color: red; color: white;\n}\n.reviewed[data-v-6fb02644] { background-color: green; color: white;\n}\n", ""]);
// Exports
module.exports = exports;
